import { render } from "./OidcCallback.vue?vue&type=template&id=30419170&scoped=true"
import script from "./OidcCallback.vue?vue&type=script&lang=js"
export * from "./OidcCallback.vue?vue&type=script&lang=js"

import "./OidcCallback.vue?vue&type=style&index=0&id=30419170&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30419170"]])

export default __exports__